$(function(){

    // 子メニューを開く
    if (window.innerWidth < 989) {
        $('.has-submenu details').attr('open',true);
    }

    // リサイズ時の処理
    let wCheck = window.innerWidth;
    function smResize(){
        if (wCheck < 989 && window.innerWidth >= 989) {
            // PC
        }else if(wCheck >= 989 && window.innerWidth < 989){
            // SP

            // 子メニューを開く
            $('.has-submenu details').attr('open',true);
        }
    }
    $(window).on('load resize orientationchange',function (){
        smResize();
        wCheck = window.innerWidth;
    });


    //sp版グローバルメニューの開閉に応じてヘッダーの見た目を変える
    $('#Details-menu-drawer-container').click(function (){
        if(!$(this).attr('open')){
            $('.header-wrapper').addClass('is-menu-open');
        }else{
            $('.header-wrapper').removeClass('is-menu-open');
        }
    });


    // note取得
    const domain  = 'https://komeko-mirin.jp';
    $.ajax({
        url: domain + '/api/get/notes',
        success: function(data) {
            const $articles = $('.blog__posts.articles-wrapper');
            const $template = $articles.find('.blog__post.grid__item').eq(0);
            let limit = 3;
            for(entry of data['entries']){
                if(limit-- <= 0){
                    break
                }
                const $article = $template.clone();

                const date = new Date(entry.publishAt.date);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const formattedDate = `${year}.${month}.${day}`;

                $article.find('.card__heading.h2 a').text(entry.title);
                $article.find('.card__heading.h2 a').attr('href', entry.url);
                $article.find('.card__heading.h2 a').attr('target', '_blank');
                $article.find('.article-card__info.h5 span').text(formattedDate);
                $article.find('.article-card__excerpt').text(entry.content);
                $article.find('img').attr('srcset', '');
                $article.find('img').attr('src', domain + entry.eyecatch);
                $article.find('img').attr('alt', entry.title);
                $articles.append($article);
            }
            $template.hide();
            $('.slider-mobile-gutter').addClass('is-show');
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader ("Authorization", "Basic " + btoa('test:test'));
        },
    });

    // CUSTOMERS VOICE
    const voiceItem = '.jdgm-carousel-item';
    if($(voiceItem).length){
        $(voiceItem).each(function (){
            let title = $(this).find('.jdgm-carousel-item__product-title').text()
            $(this).attr('title',title);
        });

        // CUSTOMERS VOICEをクリックで一覧画面へ遷移
        $(window).on('click',voiceItem,function (){
            let href = $(this).find('.jdgm-carousel-item__product').attr('href');
            // ショップレビューはレビュー一覧ページへ、商品レビューは個別商品ページへジャンプ
            if(href === "/#judgeme_product_reviews"){
                window.location.href = '/pages/customers-voice';
            }else{
                window.location.href = href;
            }
        });
    }

});

